"use strict";

var _regeneratorRuntime = require("C:\\Users\\vanro\\Desktop\\react-projects\\Portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\vanro\\Desktop\\react-projects\\Portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("C:\\Users\\vanro\\Desktop\\react-projects\\Portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\vanro\\Desktop\\react-projects\\Portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\vanro\\Desktop\\react-projects\\Portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\vanro\\Desktop\\react-projects\\Portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\vanro\\Desktop\\react-projects\\Portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Remover = void 0;

var ExternalInteractorBase_1 = require("../../../Core/Utils/ExternalInteractorBase");

var Remover = /*#__PURE__*/function (_ExternalInteractorBa) {
  _inherits(Remover, _ExternalInteractorBa);

  function Remover(container) {
    var _this;

    _classCallCheck(this, Remover);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Remover).call(this, container));

    _this.handleClickMode = function (mode) {
      if (mode !== "remove") {
        return;
      }

      var container = _this.container;
      var options = container.actualOptions;
      var removeNb = options.interactivity.modes.remove.quantity;
      container.particles.removeQuantity(removeNb);
    };

    return _this;
  }

  _createClass(Remover, [{
    key: "isEnabled",
    value: function isEnabled() {
      return true;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function () {
      var _interact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function interact() {
        return _interact.apply(this, arguments);
      }

      return interact;
    }()
  }]);

  return Remover;
}(ExternalInteractorBase_1.ExternalInteractorBase);

exports.Remover = Remover;